import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Tutorial from './Tutorial';
import soundManager from '../utils/SoundManager';
import './Home.css';

function Home() {
  const navigate = useNavigate();
  const [showTutorial, setShowTutorial] = useState(false);
  const [isHost, setIsHost] = useState(false);
  const [audioInitialized, setAudioInitialized] = useState(false);

  // Initialize audio on first interaction
  const initAudio = async () => {
    if (!audioInitialized) {
      await soundManager.init();
      setAudioInitialized(true);
    }
  };

  const handleHostClick = async () => {
    await initAudio();
    soundManager.playClick();
    navigate('/host');
  };

  const handlePlayerClick = async () => {
    await initAudio();
    soundManager.playClick();
    navigate('/play');
  };

  const handleTutorialClick = async (host) => {
    await initAudio();
    soundManager.playClick();
    setIsHost(host);
    setShowTutorial(true);
  };

  // Animated background particles effect
  useEffect(() => {
    const createParticle = () => {
      const container = document.querySelector('.home-container');
      if (!container) return;
      
      const particle = document.createElement('div');
      particle.className = 'floating-particle';
      particle.style.left = Math.random() * 100 + '%';
      particle.style.animationDuration = (Math.random() * 10 + 10) + 's';
      particle.style.opacity = Math.random() * 0.5 + 0.1;
      particle.style.fontSize = (Math.random() * 20 + 10) + 'px';
      particle.innerHTML = ['✨', '🎯', '🎮', '🏆', '⭐', '💫'][Math.floor(Math.random() * 6)];
      container.appendChild(particle);
      
      setTimeout(() => particle.remove(), 20000);
    };

    const interval = setInterval(createParticle, 2000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="home-container">
      {/* Animated background elements */}
      <div className="bg-orb bg-orb-1"></div>
      <div className="bg-orb bg-orb-2"></div>
      <div className="bg-orb bg-orb-3"></div>

      <div className="home-content">
        <div className="logo-container">
          <span className="logo-icon">🎯</span>
          <h1 className="game-title">Buzzer Bash</h1>
        </div>
        <p className="game-subtitle">Fast-paced party trivia for up to 10 players</p>
        
        <div className="button-group">
          <button 
            className="btn btn-host"
            onClick={handleHostClick}
          >
            <span className="btn-icon">🎮</span>
            <span className="btn-text">Host a Game</span>
            <span className="btn-subtitle">Display on TV/Screen</span>
          </button>
          <button 
            className="btn btn-player"
            onClick={handlePlayerClick}
          >
            <span className="btn-icon">📱</span>
            <span className="btn-text">Join as Player</span>
            <span className="btn-subtitle">Play on your phone</span>
          </button>
        </div>

        <div className="quick-start">
          <h3>Quick Start</h3>
          <div className="quick-steps">
            <div className="step">
              <div className="step-number">1</div>
              <div className="step-text">Host shares room code</div>
            </div>
            <div className="step-arrow">→</div>
            <div className="step">
              <div className="step-number">2</div>
              <div className="step-text">Players join on phones</div>
            </div>
            <div className="step-arrow">→</div>
            <div className="step">
              <div className="step-number">3</div>
              <div className="step-text">Answer fast to win!</div>
            </div>
          </div>
        </div>

        <div className="tutorial-buttons">
          <button 
            className="btn-tutorial"
            onClick={() => handleTutorialClick(true)}
          >
            📖 Host Tutorial
          </button>
          <button 
            className="btn-tutorial"
            onClick={() => handleTutorialClick(false)}
          >
            📖 Player Tutorial
          </button>
        </div>

        <div className="features">
          <div className="feature">
            <span className="feature-icon">🎲</span>
            <span className="feature-text">5 Game Modes</span>
          </div>
          <div className="feature">
            <span className="feature-icon">🧠</span>
            <span className="feature-text">9 Trivia Topics</span>
          </div>
          <div className="feature">
            <span className="feature-icon">🔥</span>
            <span className="feature-text">Streak Bonuses</span>
          </div>
        </div>
      </div>

      {showTutorial && (
        <Tutorial 
          onClose={() => setShowTutorial(false)} 
          isHost={isHost}
        />
      )}
    </div>
  );
}

export default Home;
